import type { ContactInfo, PersonalInfo } from '@/types'

export const contactInfo: ContactInfo = {
  // Email intentionally omitted from the public site to avoid scraper spam.
  // Reach out via LinkedIn or GitHub instead, or set up a forwarding alias
  // (e.g., hello@christopherrobertwhite.com) and add it back here.
  location: 'Washington, DC',
  linkedin: 'https://www.linkedin.com/in/christopherrobertwhite/',
  github: 'https://github.com/chrisrwhite',
  website: 'https://christopherrobertwhite.com',
}

export const personalInfo: PersonalInfo = {
  name: 'Christopher Robert White',
  displayName: 'Chris White',
  title: 'Optimization & ML Engineer',
  bio: 'I build optimization and ML systems that decide where products get made, shipped, and stocked. I take things from zero to one: rough prototype to something people actually use to make decisions.',
  avatar: '/avatar.png',
  resume: '/resume.pdf',
  resumeDownloadName: 'Christopher_Robert_White_Resume.pdf',
  contact: contactInfo,
}
